import { useEffect, useMemo, useState } from 'react';
import useProjectAccess from './useProjectAccess';
import { getActivity } from '../services/CollabService';
import { actorDisplay, peopleBySub } from '../utils/actorNames';

/**
 * `(actorId) => { name, email, id, known }` for a project's commit authors: its owner and members (useProjectAccess),
 * completed by the people the activity timeline names. Until they are loaded (or when neither answers) the id is shown.
 */
export default function useActorNames(projectId) {
  const { access } = useProjectAccess(projectId);
  const [activityPeople, setActivityPeople] = useState([]);

  useEffect(() => {
    let live = true;
    setActivityPeople([]);
    if (!projectId) { return undefined; }
    getActivity(projectId, { limit: 100 })
      .then((answer) => { if (live) { setActivityPeople(Array.isArray(answer?.people) ? answer.people : []); } })
      .catch(() => {});
    return () => { live = false; };
  }, [projectId]);

  return useMemo(() => {
    const people = peopleBySub(access, activityPeople);
    return (actorId) => actorDisplay(actorId, people);
  }, [access, activityPeople]);
}
